<template>
  <div id="empty_data" class="flex-center">
    <span>{{ dataTp }}이 없습니다.</span>
    <span v-if="desc">{{ desc }}</span>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    dataTp: {
      type: String,
      default: '데이터'
    },
    desc: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
#empty_data {
  min-height: 240px;

  max-height: 620px;
  max-width: 1280px;
  margin: 0 auto;

  // background: url();
}
</style>
